if (!customElements.get('localization-form')) { 
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 750px)');
        this.header = document.querySelector('.header-wrapper');
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button.localization-form__select'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          search: this.querySelector('input[name="country_filter"]'),
          closeButton: this.querySelector('.country-selector__close-button'),
          resetButton: this.querySelector('.country-filter__reset-button'),
          searchIcon: this.querySelector('.country-filter__search-icon'),
          liveRegion: this.querySelector('#sr-country-search-results'),
        };
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
        this.addEventListener('focusout', this.closeSelector.bind(this));
        this.elements.button.addEventListener('click', this.openSelector.bind(this));

        if (this.elements.search) {
          this.elements.search.addEventListener('keyup', this.filterCountries.bind(this));
          this.elements.search.addEventListener('focus', this.onSearchFocus.bind(this));
          this.elements.search.addEventListener('blur', this.onSearchBlur.bind(this));
          this.elements.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));
        }
        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener('click', this.hidePanel.bind(this));
        }
        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener('click', this.resetFilter.bind(this));
          this.elements.resetButton.addEventListener('mousedown', (event) => event.preventDefault());
        }

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
        if (this.elements.search) {
          this.elements.search.value = '';
          this.filterCountries();
          this.elements.search.setAttribute('aria-activedescendant', '');
        }
        document.body.classList.remove('overflow-hidden-mobile');
        document.querySelector('.menu-drawer').classList.remove('country-selector-open');
        this.header.preventHide = false;
      }

      onContainerKeyDown(event) {
        const focusableItems = Array.from(this.querySelectorAll('a')).filter(
          (item) => !item.parentElement.classList.contains('hidden')
        );
        let focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
        let itemToFocus;

        switch (event.code.toUpperCase()) {
          case 'ARROWUP':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
            itemToFocus.focus();
            break;
          case 'ARROWDOWN':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
            itemToFocus.focus();
            break;
        }

        if (!this.elements.search) return;

        setTimeout(() => {
          focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
          if (focusedItemIndex > -1) {
            this.elements.search.setAttribute('aria-activedescendant', focusableItems[focusedItemIndex].id);
          } else {
            this.elements.search.setAttribute('aria-activedescendant', '');
          }
        });
      }

      onContainerKeyUp(event) {
        event.preventDefault();

        switch (event.code.toUpperCase()) {
          case 'ESCAPE':
            if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
            this.hidePanel();
            event.stopPropagation();
            this.elements.button.focus();
            break;
          case 'SPACE':
            if (this.elements.button.getAttribute('aria-expanded') == 'true') return;
            this.openSelector();
            break;
        }
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
        if (!document.body.classList.contains('overflow-hidden-tablet')) {
          document.body.classList.add('overflow-hidden-mobile');
        }
        if (this.elements.search && this.mql.matches) {
          this.elements.search.focus();
        }
        if (this.hasAttribute('data-prevent-hide')) {
          this.header.preventHide = true;
        }
        document.querySelector('.menu-drawer').classList.add('country-selector-open');
      }

      closeSelector(event) {
        if (
          event.target.classList.contains('country-selector__overlay') ||
          !this.contains(event.target) ||
          !this.contains(event.relatedTarget)
        ) {
          this.hidePanel();
        }
      }

      normalizeString(str) {
        return str
          .normalize('NFD')
          .replace(/\p{Diacritic}/gu, '')
          .toLowerCase();
      }

      filterCountries() {
        const searchValue = this.normalizeString(this.elements.search.value);
        const popularCountries = this.querySelector('.popular-countries');
        const allCountries = this.querySelectorAll('a');
        let visibleCountries = allCountries.length;

        this.elements.resetButton.classList.toggle('hidden', !searchValue);

        if (popularCountries) {
          popularCountries.classList.toggle('hidden', searchValue);
        }

        allCountries.forEach((item) => {
          const countryName = this.normalizeString(item.querySelector('.country').textContent);
          if (countryName.indexOf(searchValue) > -1) {
            item.parentElement.classList.remove('hidden');
            visibleCountries++;
          } else {
            item.parentElement.classList.add('hidden');
            visibleCountries--;
          }
        });

        if (this.elements.liveRegion) {
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.countrySelectorSearchCount.replace(
            '[count]',
            visibleCountries
          );
        }

        this.querySelector('.country-selector').scrollTop = 0;
        this.querySelector('.country-selector__list').scrollTop = 0;
      }

      resetFilter(event) {
        event.stopPropagation();
        this.elements.search.value = '';
        this.filterCountries();
        this.elements.search.focus();
      }

      onSearchFocus() {
        this.elements.searchIcon.classList.add('country-filter__search-icon--hidden');
      }

      onSearchBlur() {
        if (!this.elements.search.value) {
          this.elements.searchIcon.classList.remove('country-filter__search-icon--hidden');
        }
      }

      onSearchKeyDown(event) {
        if (event.code.toUpperCase() === 'ENTER') {
          event.preventDefault();
        }
      }
    }
  );
}


/* ============================================================
   VF / Pebble & Wick — Cinematic Localization Form Enhancements
   Safe layer on top of Dawn localization-form.js.
   Keeps country/language selection, filtering, form submit and accessibility intact.
   ============================================================ */

(() => {
  const LocalizationFormElement = customElements.get('localization-form');
  if (!LocalizationFormElement || LocalizationFormElement.prototype.__vfCinematicPatched) return;

  LocalizationFormElement.prototype.__vfCinematicPatched = true;

  const originalOpenSelector = LocalizationFormElement.prototype.openSelector;
  const originalHidePanel = LocalizationFormElement.prototype.hidePanel;
  const originalFilterCountries = LocalizationFormElement.prototype.filterCountries;
  const originalResetFilter = LocalizationFormElement.prototype.resetFilter;
  const originalOnItemClick = LocalizationFormElement.prototype.onItemClick;
  const originalOnSearchFocus = LocalizationFormElement.prototype.onSearchFocus;
  const originalOnSearchBlur = LocalizationFormElement.prototype.onSearchBlur;
  const originalOnContainerKeyDown = LocalizationFormElement.prototype.onContainerKeyDown;

  const root = document.documentElement;

  const getVisibleItems = (form) =>
    Array.from(form.querySelectorAll('a')).filter((item) => !item.parentElement?.classList.contains('hidden'));

  const setLocalizationState = (form, state, detail = {}) => {
    form.dataset.vfLocalizationState = state;

    form.classList.toggle('vf-localization-open', state === 'open');
    form.classList.toggle('vf-localization-closed', state === 'closed');
    form.classList.toggle('vf-localization-filtering', state === 'filtering');
    form.classList.toggle('vf-localization-submitting', state === 'submitting');

    root.classList.toggle('vf-localization-is-open', state === 'open');
    document.body?.classList.toggle('vf-localization-is-open', state === 'open');

    form.dispatchEvent(
      new CustomEvent(`vf:localization-${state}`, {
        bubbles: true,
        detail
      })
    );
  };

  const enhanceLocalizationForm = (form) => {
    if (!form || form.__vfCinematicEnhanced) return;
    form.__vfCinematicEnhanced = true;

    form.classList.add('vf-localization-form-enhanced');

    form.elements?.button?.classList.add('vf-localization-form__button');
    form.elements?.panel?.classList.add('vf-localization-form__panel');
    form.elements?.search?.classList.add('vf-localization-form__search');
    form.elements?.resetButton?.classList.add('vf-localization-form__reset');
    form.elements?.closeButton?.classList.add('vf-localization-form__close');

    if (form.elements?.button) {
      form.elements.button.setAttribute('aria-haspopup', 'listbox');
      form.elements.button.setAttribute(
        'aria-expanded',
        form.elements.button.getAttribute('aria-expanded') || 'false'
      );
    }

    if (form.elements?.panel) {
      form.elements.panel.setAttribute('data-vf-localization-panel', '');
    }

    form.querySelectorAll('a').forEach((item, index) => {
      item.classList.add('vf-localization-form__item');
      item.style.setProperty('--vf-localization-item-index', index);
    });

    setLocalizationState(form, form.elements?.panel?.hasAttribute('hidden') === false ? 'open' : 'closed', {
      initial: true
    });
  };

  LocalizationFormElement.prototype.openSelector = function vfOpenSelector(event) {
    const result = originalOpenSelector.call(this, event);

    const isOpen = this.elements?.button?.getAttribute('aria-expanded') === 'true';

    if (isOpen) {
      setLocalizationState(this, 'open', {
        trigger: event?.target || this.elements?.button
      });

      this.elements?.panel?.removeAttribute('aria-hidden');
      this.classList.add('vf-localization-panel-ready');
    } else {
      setLocalizationState(this, 'closed', {
        trigger: event?.target || this.elements?.button
      });

      this.elements?.panel?.setAttribute('aria-hidden', 'true');
      this.classList.remove('vf-localization-panel-ready');
    }

    return result;
  };

  LocalizationFormElement.prototype.hidePanel = function vfHidePanel() {
    let result;

    try {
      result = originalHidePanel.call(this);
    } catch (error) {
      this.elements?.button?.setAttribute('aria-expanded', 'false');
      this.elements?.panel?.setAttribute('hidden', true);
      this.elements?.search?.setAttribute('aria-activedescendant', '');
      document.body?.classList.remove('overflow-hidden-mobile');
      document.querySelector('.menu-drawer')?.classList.remove('country-selector-open');
      if (this.header) this.header.preventHide = false;

      if (error instanceof TypeError) {
        console.warn('Localization panel closed with fallback handling.', error);
      } else {
        throw error;
      }
    }

    this.elements?.panel?.setAttribute('aria-hidden', 'true');
    this.classList.remove('vf-localization-panel-ready', 'vf-localization-search-focused');
    setLocalizationState(this, 'closed');

    return result;
  };

  LocalizationFormElement.prototype.filterCountries = function vfFilterCountries(event) {
    this.classList.add('vf-localization-filtering-active');

    const result = originalFilterCountries.call(this, event);
    const visibleItems = getVisibleItems(this);
    const query = this.elements?.search?.value || '';

    this.dataset.vfVisibleCountries = String(visibleItems.length);
    this.dataset.vfFilterQuery = query;

    this.classList.toggle('vf-localization-has-query', Boolean(query));
    this.classList.toggle('vf-localization-no-results', visibleItems.length === 0);

    setLocalizationState(this, 'filtering', {
      query,
      visibleCount: visibleItems.length
    });

    window.clearTimeout(this.__vfLocalizationFilterTimeout);
    this.__vfLocalizationFilterTimeout = window.setTimeout(() => {
      this.classList.remove('vf-localization-filtering-active');
      setLocalizationState(
        this,
        this.elements?.button?.getAttribute('aria-expanded') === 'true' ? 'open' : 'closed',
        { query, visibleCount: visibleItems.length }
      );
    }, 360);

    return result;
  };

  LocalizationFormElement.prototype.resetFilter = function vfResetFilter(event) {
    this.classList.add('vf-localization-resetting');

    const result = originalResetFilter.call(this, event);

    window.setTimeout(() => {
      this.classList.remove('vf-localization-resetting', 'vf-localization-has-query', 'vf-localization-no-results');
      this.dataset.vfFilterQuery = '';
      this.dataset.vfVisibleCountries = String(getVisibleItems(this).length);
    }, 260);

    return result;
  };

  LocalizationFormElement.prototype.onItemClick = function vfOnItemClick(event) {
    const selectedValue = event.currentTarget?.dataset?.value;
    const selectedText = event.currentTarget?.textContent?.trim();

    this.classList.add('vf-localization-submitting');
    setLocalizationState(this, 'submitting', {
      selectedValue,
      selectedText
    });

    return originalOnItemClick.call(this, event);
  };

  LocalizationFormElement.prototype.onSearchFocus = function vfOnSearchFocus(event) {
    const result = originalOnSearchFocus.call(this, event);

    this.classList.add('vf-localization-search-focused');
    root.classList.add('vf-localization-search-focused');

    return result;
  };

  LocalizationFormElement.prototype.onSearchBlur = function vfOnSearchBlur(event) {
    const result = originalOnSearchBlur.call(this, event);

    this.classList.remove('vf-localization-search-focused');
    root.classList.remove('vf-localization-search-focused');

    return result;
  };

  LocalizationFormElement.prototype.onContainerKeyDown = function vfOnContainerKeyDown(event) {
    const result = originalOnContainerKeyDown.call(this, event);

    if (event.code?.toUpperCase() === 'ARROWUP' || event.code?.toUpperCase() === 'ARROWDOWN') {
      const activeItem = document.activeElement?.closest?.('a');
      if (activeItem && this.contains(activeItem)) {
        this.querySelectorAll('.vf-localization-active-item').forEach((item) => {
          if (item !== activeItem) item.classList.remove('vf-localization-active-item');
        });

        activeItem.classList.add('vf-localization-active-item');
        activeItem.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }

    return result;
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('localization-form').forEach(enhanceLocalizationForm);
  }, { once: true });

  document.addEventListener('click', (event) => {
    const item = event.target.closest?.('localization-form a, localization-form button.localization-form__select');
    if (!item) return;

    item.classList.add('vf-localization-clicked');

    window.setTimeout(() => {
      item.classList.remove('vf-localization-clicked');
    }, 420);
  });
})();
